import { paymentOptions } from '@/domain/FilterSelector'

export const uniqueValues = (value, index, self) => self.indexOf(value) === index

export const isPriceAndPoints = rate => rate.averagePricing.price && rate.averagePricing.points
export const isOnlyPrice = rate => !rate.averagePricing.points
export const isOnlyPoints = rate => !rate.averagePricing.price

export const byPayment = selectedPayment => rate => {
  if (selectedPayment.key === paymentOptions[0].key) {
    return true
  }
  if (selectedPayment.key === paymentOptions[1].key && isOnlyPrice(rate)) {
    return true
  }
  if (selectedPayment.key === paymentOptions[2].key && !isOnlyPrice(rate)) {
    return true
  }
  return false
}
